<div *ngIf="columnsData" class="res-table-expand-base" fxLayout="column" fxFlex="0 0 100%">
    <app-table-filter-expansion-panel
        [expanded]="filtersExpanded"
        class="task-expansion"
        #filterExpansion
        [hasTopBorder]="false"
    >
        <ng-content select="[tableFiltersTempl]"></ng-content>
    </app-table-filter-expansion-panel>

    <div *ngIf="canSelect && showSelectionActions" class="multi-select">
        <ng-container
            *ngTemplateOutlet="otherContext['multipleSelectionActions']; context: { $implicit: selection.selected }"
        ></ng-container>
    </div>
    <button
        *ngIf="canExpandAll && expandingTable"
        class="expand-collapse-all"
        mat-icon-button
        [matTooltip]="expandCollapseTooltip"
        (click)="toggleExpandCollapseAll(); $event.stopPropagation()"
        [ngClass]="{ isAllExpanded: isAllExpanded }"
    >
        <mat-icon>first_page</mat-icon>
    </button>
    <mat-table
        #table
        [dataSource]="dataSource"
        [matSortDirection]="matSortDirection"
        [matSortActive]="matSortActive"
        [class.showSelectionActions]="canSelect && showSelectionActions"
        matSort
        [multiTemplateDataRows]="expandingTable"
        [class.hideTableHeaderBottomBorder]="(dataSource.status | async) === 'loading'"
    >
        <ng-container matColumnDef="select">
            <mat-header-cell *matHeaderCellDef>
                <mat-checkbox
                    (click)="$event.stopPropagation()"
                    (change)="$event ? masterToggle() : null"
                    [checked]="selection.hasValue() && isAllSelected()"
                    [indeterminate]="selection.hasValue() && !isAllSelected()"
                    [aria-label]="checkboxLabel()"
                    color="primary"
                >
                </mat-checkbox>
            </mat-header-cell>
            <mat-cell *matCellDef="let resource">
                <mat-checkbox
                    (click)="$event.stopPropagation()"
                    (change)="$event ? selection.toggle(resource) : null"
                    [checked]="selection.isSelected(resource)"
                    [aria-label]="checkboxLabel(resource)"
                    color="primary"
                >
                </mat-checkbox>
            </mat-cell>
        </ng-container>
        <ng-container *ngFor="let column of columns">
            <ng-container *ngIf="column != 'select'" [matColumnDef]="column">
                <mat-header-cell
                    [class.notsortable]="!columnsKeys[column]?.sortable"
                    *matHeaderCellDef
                    [mat-sort-header]="columnsKeys[column]?.sortable ? column : null"
                >
                    <mat-icon class="label-icon-header" *ngIf="columnsKeys[column]?.icon">{{
                        columnsKeys[column]?.icon
                    }}</mat-icon>
                    {{ columnsKeys[column]?.label }}
                </mat-header-cell>
                <mat-cell *matCellDef="let resource">
                    <ng-container *ngIf="columnsData[column]">
                        <ng-container
                            *ngTemplateOutlet="columnsData[column]; context: { $implicit: resource }"
                        ></ng-container>
                    </ng-container>
                </mat-cell>
            </ng-container>
        </ng-container>

        <ng-container *ngIf="expandingTable" matColumnDef="expandedDetail">
            <mat-cell *matCellDef="let resource" [attr.colspan]="columns.length">
                <div class="example-element-detail" [@detailExpand]="expandedFn(resource) ? 'expanded' : 'collapsed'">
                    <ng-container
                        *ngTemplateOutlet="otherContext['expansionContext']; context: { $implicit: resource }"
                    ></ng-container>
                </div>
            </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
        <mat-row
            *matRowDef="let resource; columns: columns"
            (click)="rowClick.emit(resource); expandingTable && toggleExpand(resource)"
            class="example-element-row"
            [class.expandedMobileRowId]="expandedFn(resource)"
            [class.disabledRow]="!!disabledRows?.length && disabledRows.includes(resource.id)"
        ></mat-row>
        <ng-container *ngIf="expandingTable">
            <mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></mat-row>
        </ng-container>
    </mat-table>
    <mat-progress-bar
        class="{{ tableLoaderClass }}"
        *ngIf="(dataSource.status | async) === 'loading'"
        mode="indeterminate"
    ></mat-progress-bar>
    <mat-paginator [pageSize]="pageSizeOptions[0]" [pageSizeOptions]="pageSizeOptions"> </mat-paginator>
</div>
